import './CommentSection.scss';

import { CommentList } from './CommentList';
import { CommentOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { CreateCommentNotification } from './CreateCommentNotification';
import { DeleteCommentNotification } from './DeleteCommentNotification';
import { InitiativeSection } from '../general';
import { OffsetPaginator } from '@ui/OffsetPaginator';
import { UpdateCommentNotification } from './UpdateCommentNotification';

import { coreActions, InitiativeComment } from '@sonar-software/sonar-core';
import { OffsetPaginatedResource, OffsetPaginationParams } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
import { useAction, useSonarSelector } from '@hooks';

export interface CommentSectionProps {
	initiativeId: number;
}

const commentsSelectors = createAsyncSelectors((state) => state.core.initiatives.comments.get);

export const CommentSection: React.FC<CommentSectionProps> = ({ initiativeId }) => {
	const totalCount = useSonarSelector(commentsSelectors.data)?.totalCount;

	const get = useAction(coreActions.requestGetCoreInitiativesComments);

	const handleGet = useCallback(
		(args: OffsetPaginationParams) =>
			get({
				...args,
				initiativeId
			}),
		[ get, initiativeId ]
	);

	const renderComments = useCallback(
		(data: OffsetPaginatedResource<InitiativeComment>) => <CommentList
			data={ data }
			initiativeId={ initiativeId } />,
		[ initiativeId ]
	);

	return (
		<InitiativeSection
			count={ totalCount }
			icon={ <CommentOutlined /> }
			id='initiative-comments-section'
			title={ COPY_SPECIFIC.COMMENTS }>
			<OffsetPaginator
				render={ renderComments }
				request={ handleGet }
				selector={ commentsSelectors.data } />
			<CreateCommentNotification />
			<DeleteCommentNotification />
			<UpdateCommentNotification />
		</InitiativeSection>
	);
};
